import React from 'react';
import { observer } from 'mobx-react';
import { CardMainLayout, Catcher, cardLayoutOptions } from '../../index';
import { useNonRecurringChargesList } from '../../../hooks';
import { tP } from '../../../translate';
import Styles from '../../styles/m_itemCardStyles.less';

export const ShowRateNrc: React.FC = observer(() => {
    const monthlyRecurringChargesList = useNonRecurringChargesList();

    return (
        <Catcher>
            <CardMainLayout
                idSpinners={['GET_COMPANY_NON_RECURRING_PAYMENTS', 'GET_COMPANY']}
                name={tP('Non Recurring Costs')}
                columnOption={cardLayoutOptions.mrcForm}
            >
                {monthlyRecurringChargesList.length ? (
                    <div className={Styles.mrcFormItem}>
                        {monthlyRecurringChargesList.map((value) => {
                            return (
                                <div className={Styles.mrcFormItemContainer} key={value.id}>
                                    <span>{value.name}</span>
                                    <div style={{ color: 'green' }}>EUR {value.amountCents}</div>
                                </div>
                            );
                        })}
                    </div>
                ) : (
                    <div className={Styles.mrcFormEmptyContainer}>
                        <p className={Styles.mrcFormEmptyText}>No Non-Recurring Costs Yet</p>
                    </div>
                )}
            </CardMainLayout>
        </Catcher>
    );
});
